import join from 'url-join';

import { COMMON_PAGES } from '@app/common/utils/constants';

import { ChannelId } from '@make-transfer/types/common';

const channelParams = '/:subpage/:action?/:id?';
const makeTransferParams = ['/:channel', channelParams].join('');
export const MAKE_TRANSFER_ROUTE_TEMPLATE = [
  COMMON_PAGES.MAKE_TRANSFER,
  makeTransferParams,
].join('');

/**
 * returns route like /transfers-payments/make-transfer/{channel}
 * (e.g. /transfers-payments/make-transfer/internal)
 */
export const getChannelRoute = (channelId: ChannelId) => join(COMMON_PAGES.MAKE_TRANSFER, channelId);

/**
 * returns route like /transfers-payments/make-transfer/wire/edit/info
 * (e.g. /transfers-payments/make-transfer/internal)
 */
export const getChannelEditRoute = (channelId: ChannelId, id: string) => join(COMMON_PAGES.MAKE_TRANSFER, channelId, `/edit/${id}`);

/**
 * returns route like /transfers-payments/make-transfer/{channel}/*
 * (e.g. /transfers-payments/make-transfer/internal/*)
 * is used for detecting unhandled route to render <PageNotFoundDialog />
 */
export const getChannelNotFoundPageRoute = (channelId: ChannelId) => join(getChannelRoute(channelId), '/*');

/**
 * returns route like /transfers-payments/make-transfer/{channel}/payment/new
 * (e.g. /transfers-payments/make-transfer/internal/payment/new)
 * is used when we wants redirect user to payment form to proceed payment
 * if such page not exists (e.g. ACH) - will be rendered <PageNotFoundDialog />
 * this logic is handled by each channel
 */
// eslint-disable-next-line i18next/no-literal-string
export const getChannelNewPaymentRoute = (channelId: ChannelId) => join(getChannelRoute(channelId), '/payment/new');

/**
 * returns route like /transfers-payments/make-transfer/{channel}/send/new
 * (e.g. /transfers-payments/make-transfer/invoices/send/new)
 * is used when we wants redirect user to sending form to proceed payment
 * if such page not exists (e.g. ACH) - will be rendered <PageNotFoundDialog />
 * this logic is handled by each channel
 */
// eslint-disable-next-line i18next/no-literal-string
export const getChannelSendNewRoute = (channelId: ChannelId) => join(getChannelRoute(channelId), '/send/new');

/**
 * returns route template like /transfers-payments/make-transfer/{channel}/:subpage/:action?/id?
 * (e.g. /transfers-payments/make-transfer/internal/:subpage/:action?/:id?)
 * to match params inside of channel's components
 */
export const getChannelRouteTemplate = (channelId: ChannelId) => (
  [getChannelRoute(channelId), channelParams].join('')
);
